// extracted by mini-css-extract-plugin
module.exports = {"dialog--inner":"dialog--inner__1W84a"};